export default __webpack_public_path__ + "static/media/five.557cf316.jpg";